// extracted by mini-css-extract-plugin
export var chevron = "_g2-2";
export var dropdownItems = "_g2-0";
export var item = "_g2-1";